// const checkPopup = document.getElementById('popup');
// if (checkPopup) {
//   // ポップアップを表示する関数
//   function showPopup() {
//     const popup = document.getElementById('popup');
//     popup.classList.remove('popup_hidden');
//   }

//   // ポップアップを閉じる関数
//   function closePopup() {
//     const popup = document.getElementById('popup');
//     popup.classList.add('popup_hidden');
//     sessionStorage.setItem('popupClosed', 'true'); // セッションに表示済みフラグを保存
//   }

//   // ページが読み込まれたときに実行
//   window.onload = function() {
//     const popupClosed = sessionStorage.getItem('popupClosed');

//     // popupClosedがない場合のみポップアップを表示
//     if (!popupClosed) {
//       showPopup();
//     }

//     document.getElementById('close_popup').onclick = closePopup;
//   };
// }



const checkPopup = document.getElementById('popup');
if (checkPopup) {
  // ポップアップを表示する関数
  function showPopup() {
    const popup = document.getElementById('popup');
    popup.classList.remove('popup_hidden');
  }

  // ポップアップを閉じる関数
  function closePopup() {
    const popup = document.getElementById('popup');
    popup.classList.add('popup_hidden');
    
    // 現在時刻を保存（ミリ秒）
    const now = new Date().getTime();
    localStorage.setItem('popupClosed', now);
  }

  // ページが読み込まれたときに実行
  window.onload = function() {
    const popupClosed = localStorage.getItem('popupClosed');

    // popupClosedがない、または24時間以上経過している場合のみポップアップを表示
    const now = new Date().getTime();
    if (!popupClosed || now - popupClosed > 24 * 60 * 60 * 1000) {
      showPopup();
    }

    document.getElementById('close_popup').onclick = closePopup;
  };
}